import React from 'react';
import PropTypes from 'prop-types';

const CustomOutlined = ({ children, onClick, style, ...props }) => {
  const buttonStyle = {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '16px 24px',
    gap: '10px',
    minWidth: '205px',
    height: '57px',
    border: '2px solid #148536',
    borderRadius: '8px',
    backgroundColor: 'transparent',
    
    fontWeight: 'bold',
    cursor: 'pointer',
    color:'#148536',
    ...style, // Allow overriding styles via props
  };

  return (
    <button style={buttonStyle}  className='text-[20px]' onClick={onClick} {...props}>
      {children}
    </button>
  );
};

CustomOutlined.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  style: PropTypes.object,
};

CustomOutlined.defaultProps = {
  onClick: () => {},
  style: {},
};

export default CustomOutlined;